'use client';

import { usePathname } from 'next/navigation';
import ClientNavbar from '@/components/layout/ClientNavbar';
import ClientFooter from '@/components/layout/ClientFooter';

const ROUTES_WITHOUT_LAYOUT = ['/professionals/register'];

export default function LayoutWrapper({ children, fullHeight = true }) {
  const pathname = usePathname();
  const shouldShowNavAndFooter = !ROUTES_WITHOUT_LAYOUT.includes(pathname);

  if (!shouldShowNavAndFooter) {
    return <div className="min-h-screen">{children}</div>;
  }

  // Use different padding for error pages
  const paddingClasses = fullHeight
    ? 'pt-36 md:pt-[7.5rem] lg:pt-[7.9rem] xl:pt-[8.2rem]'
    : 'md:pt-10 lg:pt-[30px] xl:mt-[1rem]';

  return (
    <>
      <ClientNavbar />
      <div className={`${fullHeight ? 'min-h-screen' : 'min-h-[500px]'} ${paddingClasses}`}>
        {children}
      </div>
      <ClientFooter />
    </>
  );
};
